import { render, staticRenderFns } from "./TabConfiguratorContributors.vue?vue&type=template&id=29f5c036&"
import script from "./TabConfiguratorContributors.vue?vue&type=script&lang=js&"
export * from "./TabConfiguratorContributors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports